/**
 * TypeScript version of classcat library
 * https://github.com/jorgebucaran/classcat/
 */

type NameObject = {
  [key: string]: boolean | null | undefined;
};

type Name = string | number | null | undefined | NameObject | Name[];

export function cx(names: Name): string {
  if (typeof names === 'string' || typeof names === 'number') {
    return '' + names;
  }

  let out = '';

  if (Array.isArray(names)) {
    for (let i = 0, tmp; i < names.length; i++) {
      if ((tmp = cx(names[i])) !== '') {
        out += (out && ' ') + tmp;
      }
    }
  } else if (names && typeof names === 'object') {
    for (const k in names) {
      if (names[k]) {
        out += (out && ' ') + k;
      }
    }
  }

  return out;
}
